import { RolesPage as SharedRolesPage } from '@trinetra/shared';

/** Cloud permission category display names. */
const CATEGORY_LABELS: Record<string, string> = {
  nodes: 'Sites',
  monitoring: 'Monitoring',
  turn: 'TURN',
  alerts: 'Alerts',
  'multi-site': 'Multi-Site',
  users: 'Users',
  roles: 'Roles',
  settings: 'Settings',
};

/** Cloud roles = permissions only (no role→group access). */
export default function RolesPage() {
  return <SharedRolesPage categoryLabels={CATEGORY_LABELS} />;
}
